<mat-form-field *ngIf="!isTodayOpened">
  <mat-label> {{ label }} </mat-label>
  <input
    matInput
    [formControl]="dateTimeRangeControl"
    [owlDateTime]="datetimePicker"
    [owlDateTimeTrigger]="datetimePicker"
    [selectMode]="'range'"
    [readonly]="true"
  />

  <ng-container *ngIf="prefix" matPrefix>
    <ng-container *ngTemplateOutlet="prefix"></ng-container>
  </ng-container>

  <ng-container matSuffix>
    <ng-container *ngIf="!suffix; else suffix">
      <ui-svg-icon
        [name]="iconNames.CalendarClock"
        class="tw-pointer tw-align-middle"
        (click)="datetimePicker.open()"
      ></ui-svg-icon>
      <ui-svg-icon
        [name]="iconNames.Add"
        class="add tw-cursor-pointer tw-align-middle"
        (click)="open($event, combinedDateTimeRangeType.TodayShift)"
      ></ui-svg-icon>
    </ng-container>
  </ng-container>

  <owl-date-time #datetimePicker [pickerType]="pickerType"> </owl-date-time>
</mat-form-field>

<mat-form-field
  *ngIf="isTodayOpened"
  [class.visible]="isRelativeDateRangesVisible"
  (click)="toggleRelativeDateRangesVisibility($event)"
>
  <mat-label> {{ label }} </mat-label>
  <input matInput [formControl]="relativeDateRanges" [readonly]="true" />
  <div *ngIf="isRelativeDateRangesVisible" (click)="$event.stopPropagation()" class="tw-flex-col tw-pt-2">
    <form [formGroup]="relativeDateRangesFormGroup">
      <div class="tw-flex">
        <span class="tw-pr-4 tw-text-base tw-leading-[48px]"> {{ 'common.text.from' | translate }}: </span
        ><input matInput type="number" class="tw-max-w-[60px] tw-border-0" formControlName="from" />
        <span class="tw-pl-2 tw-pr-4 tw-text-base tw-leading-[48px]"
          >{{ 'common.text.days' | translate }} {{ 'common.text.to' | translate }}: </span
        ><input matInput type="number" class="tw-max-w-[60px] tw-border-0" formControlName="to" />
      </div>
      <div class="tw-text-base tw-leading-4">
        <mat-checkbox formControlName="onlyWorkDays">
          {{ 'common.text.workingDays' | translate }}
        </mat-checkbox>
      </div>
    </form>
    <mat-error>
      <ui-field-error-messages [control]="relativeDateRangesFormGroup" class="tw-text-sm"></ui-field-error-messages>
    </mat-error>
    <mat-error>
      <ui-field-error-messages
        [control]="relativeDateRangesFormGroup.get('from')"
        class="tw-text-sm"
      ></ui-field-error-messages>
    </mat-error>
    <mat-error>
      <ui-field-error-messages
        [control]="relativeDateRangesFormGroup.get('to')"
        class="tw-text-sm"
      ></ui-field-error-messages>
    </mat-error>
  </div>

  <ng-container *ngIf="prefix" matPrefix>
    <ng-container *ngTemplateOutlet="prefix"></ng-container>
  </ng-container>

  <ng-container matSuffix>
    <ng-container *ngIf="!suffix; else suffix">
      <ui-svg-icon
        [name]="iconNames.CalendarClock"
        class="tw-cursor-pointer tw-align-middle"
        (click)="open($event, combinedDateTimeRangeType.Range)"
      ></ui-svg-icon>
      <ui-svg-icon
        [name]="iconNames.Add"
        class="add tw-cursor-pointer tw-align-middle"
        (click)="open($event, combinedDateTimeRangeType.TodayShift)"
      ></ui-svg-icon>
    </ng-container>
  </ng-container>
</mat-form-field>
